import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import moment from "moment";
import supabase from "../../supabase";
import { getCheckStateLabel } from "../../utils/checkStateLogger";

const SOURCE_LABELS = {
  cashMovements: "Movimiento de caja",
  cashExtraction: "Extracción de caja",
};

const CheckHistoryModal = ({ open, onClose, paymentDetailsId, checkNumber }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && paymentDetailsId != null) {
      getHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, paymentDetailsId]);

  const getHistory = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from("checkStateHistory")
        .select("*")
        .eq("paymentDetailsId", paymentDetailsId)
        .order("createdAt", { ascending: true });

      if (error) throw error;
      setHistory(data || []);
    } catch (error) {
      console.error("Error al obtener el historial del cheque:", error);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Historial del cheque{checkNumber ? ` N° ${checkNumber}` : ""}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : history.length === 0 ? (
          <Typography sx={{ py: 2 }}>
            No hay cambios de estado registrados para este cheque.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Fecha y hora</TableCell>
                <TableCell>Estado anterior</TableCell>
                <TableCell>Estado nuevo</TableCell>
                <TableCell>Usuario</TableCell>
                <TableCell>Origen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    {moment(item.createdAt).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell>
                    {item.previousState != null
                      ? getCheckStateLabel(item.previousState)
                      : "-"}
                  </TableCell>
                  <TableCell>{getCheckStateLabel(item.newState)}</TableCell>
                  <TableCell>{item.changedBy || "-"}</TableCell>
                  <TableCell>
                    {SOURCE_LABELS[item.source] || item.source || "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckHistoryModal;
